<div class="teaser-container">
  <div class="content {{ contentAlignment }}">
    <div class="text {{ colorSchema }}">
      <div class="text-content">
        <div class="headline {{ colorSchema }} {{ fontSize }}">
          <kion-headline-tag
            [title]="title"
            [titleSize]="titleSize"
          ></kion-headline-tag>
        </div>
        <div class="description {{colorSchema}}"> {{ description }} </div>
        <div class="cta" *ngIf="link">
          <kion-button class="{{colorSchema}}" mode="primary" [link]="link" [isLink]="true" [title]="link.linkName"></kion-button>
        </div>
      </div>
    </div>
    <div class="image {{ colorSchema }} {{ contentAlignment }}">
      <div class="tilt">
        <svg class="default" viewBox="0 0 50 400">
          <path d="M 0 0 L 50 0 L 0 400 Z" />
        </svg>
        <svg class="mobile" viewBox="0 0 400 30">
          <path d="M 0 30 L 400 30 L 400 0 Z" />
        </svg>
      </div>
      <img
        *ngIf="image; else noImage"
        [lazyLoad]="image.url + '?width=1050&height=700&padColor=fff'"
        [defaultImage]="image.url + '?width=50&height=50&padColor=fff'"
        errorImage="./assets/ui/shared/error/not_found_error_image.png"
        [alt]="image.altText"
        [title]="image.titleText || image.altText"
        src="#"
        width="100%"
        height="100%"
      />
      <ng-template #noImage>
        <img
          alt="missing_teaser"
          title="missing_teaser"
          src="./assets/ui/shared/error/not_found_error_image.png"
          width="100%"
          height="100%"
        />
      </ng-template>
    </div>
  </div>
</div>
